function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { useContext } from 'react';
import ReactDOMServer from 'react-dom/server';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopyright } from '@fortawesome/free-solid-svg-icons';
import { LatLng } from 'leaflet';
import { Map, GeoJSON, Popup, TileLayer, Marker, Polyline, LayerGroup } from 'react-leaflet';
import { isAndroid } from 'react-device-detect';
import 'leaflet/dist/leaflet.css';
import './MapPanel.css';

var TrackIcon = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TrackIcon, _React$PureComponent);

  function TrackIcon() {
    _classCallCheck(this, TrackIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(TrackIcon).apply(this, arguments));
  }

  _createClass(TrackIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          track = _this$props.track,
          map = _this$props.map;
      return React.createElement("svg", {
        width: "25px",
        height: "25px",
        viewBox: "0 0 42 42",
        className: "track-icon-svg ".concat(active ? 'active' : 'inactive')
      }, React.createElement("circle", {
        className: "hole",
        cx: "21",
        cy: "21",
        r: "16",
        fill: "".concat(active ? 'rgba(72, 87, 94, .9)' : 'rgba(72, 87, 94, .7)')
      }), React.createElement("circle", {
        className: "ring",
        cx: "21",
        cy: "21",
        r: "16",
        fill: "transparent",
        stroke: "".concat(active ? 'rgba(101, 219, 146, .9)' : 'rgba(132, 137, 154, .8)'),
        strokeWidth: "5"
      }));
    }
  }]);

  return TrackIcon;
}(React.PureComponent);

var MapPanel = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(MapPanel, _React$PureComponent2);

  function MapPanel(props) {
    var _this;

    _classCallCheck(this, MapPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MapPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "openAttribution", function () {
      if (window.cordova) {
        if (isAndroid) {
          cordova.InAppBrowser.open("https://osm.org/copyright");
        } else {
          cordova.InAppBrowser.open("https://osm.org/copyright", "_system", {
            usewkwebview: 'yes'
          });
        }
      } else {
        window.open("https://osm.org/copyright", "_system");
      }
    });

    _this.mapRef = React.createRef();
    return _this;
  }

  _createClass(MapPanel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          app = _this$props2.app,
          tracks = _this$props2.tracks,
          activeTrack = _this$props2.activeTrack,
          center = _this$props2.center,
          width = _this$props2.width,
          height = _this$props2.height;
      return React.createElement(Map, {
        className: "track-map",
        ref: this.mapRef,
        center: center,
        zoom: 14,
        maxZoom: 16,
        attributionControl: false,
        zoomControl: false,
        doubleClickZoom: true,
        scrollWheelZoom: true,
        dragging: true,
        animate: true,
        easeLinearity: 0.35,
        onViewportChanged: function onViewportChanged(e) {
          return app.onViewportChanged(e, _this2.mapRef.current);
        },
        whenReady: function whenReady(e) {
          return app.mapReady(_this2.mapRef.current);
        },
        onDblClick: this.mapDoubleClicked,
        style: {
          width: "".concat(width, "px"),
          height: "".concat(height, "px"),
          margin: '0 auto',
          overflow: 'hidden'
        }
      }, React.createElement(TileLayer, {
        url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png'
      }), tracks.map(function (track) {
        var icon = L.divIcon({
          className: "track-icon",
          html: ReactDOMServer.renderToString(React.createElement(TrackIcon, {
            track: track,
            active: activeTrack === track
          }))
        });
        return React.createElement(LayerGroup, {
          key: track.id
        }, React.createElement(Marker, {
          position: track.position,
          icon: icon,
          key: "".concat(track.id, "-marker"),
          onClick: function onClick(e) {
            app.setActiveTrack(track);
          }
        }));
      }), React.createElement("div", {
        className: "attribution",
        onClick: this.openAttribution,
        style: {
          bottom: window.cordova ? '2px' : '5px'
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faCopyright
      }), " OpenStreetMap contributors"));
    }
  }]);

  return MapPanel;
}(React.PureComponent);

export default MapPanel;